<b-container fluid="sm">
    <b-row align-v="center">
        <b-col cols="12" md="6">
            <b-card type="secondary" shadow header-classes="bg-white">
                <b-card-text>
                    <b-form enctype="multipart/form-data">
                        <!---->
                        <legend>Recepient Details</legend>
                        <hr />
                        <b-row>
                            <b-col>
                                <b-form-group label="Number for ticket recepient:" label-for="input-1">
                                    <vue-phone-number-input id="Umbai" v-model="receiverNumber"
                                    size="lg"
                                        default-country-code="ZA" no-example required
                                        @update="ValidateReceiverNumber" />
                                    <div><span class="text-warning"></span></div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <br />
                        <!---->
                        <div>
                            <b-button type="button" @click='proceed' variant="primary" class="my-4">
                                Proceed
                            </b-button>
                        </div>
                    </b-form>
                </b-card-text>
            </b-card>
        </b-col>
    </b-row>
</b-container>